export const TESTIMONIALS = [
  {
    name: "Jennifer & Mark D.",
    town: "Marlboro, NJ",
    rating: 5,
    project: "Kitchen Remodel",
    text: "From the first walkthrough, the Ardeca team listened to exactly what was stressing us out about our cramped kitchen. They handled everything, kept the site spotless, and finished on schedule. We finally have the kitchen we always wanted.",
  },
  {
    name: "Anthony R.",
    town: "Freehold, NJ",
    rating: 5,
    project: "Basement Renovation",
    text: "Our basement went from a damp storage dump to the favorite room in the house. Honest pricing, no surprises, and a crew that treated our home like their own. I recommend Ardeca to every neighbor who asks.",
  },
  {
    name: "Sophia L.",
    town: "Colts Neck, NJ",
    rating: 5,
    project: "Bathroom Remodel",
    text: "I was nervous about a full bathroom gut. Ardeca walked me through every decision, respected my budget, and the result feels like a spa. A true family business that actually cares.",
  },
  {
    name: "David & Karen P.",
    town: "Holmdel, NJ",
    rating: 5,
    project: "Custom Deck",
    text: "26 years of experience really shows. Our new deck is rock-solid, beautiful, and built to handle Jersey winters. The communication throughout was the best we've had with any contractor.",
  },
  {
    name: "Michael S.",
    town: "Middletown, NJ",
    rating: 5,
    project: "Interior Painting",
    text: "Flawless lines, zero mess, and they finished a day early. You can tell they take pride in the small details. Our whole first floor looks brand new.",
  },
  {
    name: "Rachel T.",
    town: "Manalapan, NJ",
    rating: 5,
    project: "Commercial Build-Out",
    text: "Ardeca handled the build-out of our retail space with total professionalism. On budget, on time, and they kept us open for business throughout. Exactly the reliable partner we needed.",
  },
];
